import axios from 'axios';

const state = {
  accessToken: null,
  user: {},
  waitingStatistics: false,
  gameId: null,
  provider: null,
  isDataFetched: false,
  interceptorsLogin: false,
};

const getters = {
  isAuthenticated(localState) {
    return localState.accessToken !== null;
  },
  userInfo(localState) {
    return localState.user;
  },
  userTeams: localState => payload => localState.user.teams.filter(item => item[payload.key] === payload.value),
  userTeamsLength(localState) {
    return localState.user.teams.length;
  },
  authUserCity(localState) {
    return localState.user.cityObj;
  },
};

const mutations = {
  updateToken(localState, newToken) {
    if (newToken === null) {
      localState.accessToken = null;
      axios.defaults.headers.Authorization = null;
    } else {
      localState.accessToken = newToken;
    }
    if (newToken) {
      axios.defaults.headers.Authorization = `Bearer ${newToken}`;
    }
  },
  updateUser(localState, newUser) {
    if (!Object.keys(newUser).length) {
      localState.user = {};
    } else {
      localState.user = newUser;
      localState.isDataFetched = true;
    }
  },
  UPDATE_USER_DATA(localState, payload) {
    Object.assign(localState.user, payload);
  },
  updateGameId(localState, newId) {
    if (!newId) {
      localState.gameId = null;
    } else {
      localState.gameId = newId;
    }
  },
  updateProvider(localState, newProvider) {
    if (!newProvider) {
      localState.provider = null;
    } else {
      localState.provider = newProvider;
    }
  },
  SET_FETCHED_DATA(localState, isFetched) {
    localState.isDataFetched = isFetched;
  },
  ADD_USER_TEAMS(localState, team) {
    const teamIndex = localState.user.teams.findIndex(item => item.id === team.id);
    if (teamIndex >= 0) {
      Object.assign(localState.user.teams[teamIndex], team);
      console.log(team, localState.user.teams[teamIndex]);
    } else {
      localState.user.teams = [...localState.user.teams, team];
    }
  },
  REMOVE_USER_TEAM(localState, teamId) {
    localState.user.teams = localState.user.teams.filter(item => item.id !== teamId);
  },

  ADD_USER_APPLICATION(localState, newApplication) {
    localState.user.applications = [...localState.user.applications, newApplication];
  },
  REMOVE_USER_APPLICATION(localState, appId) {
    localState.user.applications = localState.user.applications.filter(item => item.id !== appId);
  },
  UPDATE_USER_APPLICATION(localState, payload) {
    const tempApplicationIndex = localState.user.applications.findIndex(item => item.id === payload.id);
    Object.assign(localState.user.applications[tempApplicationIndex], payload);
  },
  UPDATE_INTERCEPTORS_LOGIN(localState, payload) {
    localState.interceptorsLogin = payload;
  },
  SET_PARTNER_CITY_OBJECT(localState, cityObj) {
    localState.user.cityObj = cityObj;
  },
  SET_PARTNER_WAITING_STATISTICS(localState, waitingStatistics) {
    localState.waitingStatistics = waitingStatistics;
  },
};

const actions = {
  setToken({ commit }, token) {
    commit('updateToken', token);
  },
  setUser({ commit }, user) {
    commit('updateUser', user);
  },
  updateUserData({ commit }, payload) {
    commit('UPDATE_USER_DATA', payload);
  },
  refreshUser({ commit }, client) {
    let user = {};
    client.get('/me')
      .then((response) => {
        user = response.data;
        commit('updateUser', user);
        commit('SET_FETCHED_DATA', true);
      });
  },
  setFetchedData({ commit }, isFetched) {
    commit('SET_FETCHED_DATA', isFetched);
  },
  logout({ commit }) {
    commit('updateToken', null);
    commit('updateUser', {});
    commit('SET_FETCHED_DATA', false);
  },
  setGameId({ commit }, gameId) {
    commit('updateGameId', gameId);
  },
  setProvider({ commit }, provider) {
    commit('updateProvider', provider);
  },
  addUserTeams({ commit }, newTeam) {
    console.log(newTeam);
    commit('ADD_USER_TEAMS', newTeam);
  },
  removeUserTeam({ commit }, teamId) {
    commit('REMOVE_USER_TEAM', teamId);
  },
  addUserApplication({ commit }, newApplication) {
    commit('ADD_USER_APPLICATION', newApplication);
  },
  removeUserApplication({ commit }, appId) {
    commit('REMOVE_USER_APPLICATION', appId);
  },
  updateUserApplication({ commit }, payload) {
    commit('UPDATE_USER_APPLICATION', payload);
  },
  updateInterceptorsLogin({ commit }, payload) {
    commit('UPDATE_INTERCEPTORS_LOGIN', payload);
  },
  setPartnerCityObject({ commit }, cityObj) {
    commit('SET_PARTNER_CITY_OBJECT', cityObj);
    commit('SET_PARTNER_WAITING_STATISTICS', cityObj.waiting_statistics);
  },
  setPartnerWaitingStatistics({ commit }, waitingStatistics) {
    commit('SET_PARTNER_WAITING_STATISTICS', waitingStatistics);
  },
};

export default {
  state,
  actions,
  getters,
  mutations,
};
